/**
 * @desc abolishTms
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.transportToDetailFacadeImpl.abolishTms.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/abolishTms`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
